<template>
  <b-card class="card-post">
    <div>
      <p class="date">
        <PuSkeleton :loading="isLoading" :count="1" width='90px'>                        
          {{date}}
        </PuSkeleton>
      </p>
      <h4 class="title">
        <PuSkeleton :loading="isLoading" :count="1">                                
          {{title}}
        </PuSkeleton>  
      </h4>
      <p class="desc">
        <PuSkeleton :loading="isLoading" :count="3">        
          {{desc}}
        </PuSkeleton>
      </p>
    </div>

    <b-button class="btn-post" :to="link" variant="link">
      <PuSkeleton :loading="isLoading" :count="1" width='120px'>      
        {{linkTitle}}
      </PuSkeleton>
    </b-button>
  </b-card>
</template>


<script>
//
export default {
  name: "CardPost",
  components:{ 
  },
  props:{
      date:{
        type:String,
        default:"27 avril 2020"
      },     
      title:{
        type:String,
        default:'Fermentum nisi elit, at porta orci vulputate quis.'
      },
      desc:{
        type:String,
        default:'Fermentum nisi elit, at porta orci vulputate quis.'
      },
      linkTitle:{
        type:String,
        default:'En savoir plus'
      },
      link:{
        type:String,
        default:'#'
      }
  },
  data(){
    return {
        isLoading:true,
    }
  },
  created(){
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },3000)      
  }  
}
</script>